import type { FieldErrors } from 'react-hook-form';

// Recursively traverse the errors object
export const extractFieldErrors = (errors: FieldErrors, parentPath = ''): string[] => {
    const messages: string[] = [];

    for (const [key, value] of Object.entries(errors)) {
        const currentPath = parentPath ? `${parentPath}.${key}` : key;

        if (value?.message) {
            messages.push(`${currentPath}: ${value.message}`);
        }

        if (value && typeof value === 'object' && !value.message) {
            messages.push(...extractFieldErrors(value as FieldErrors, currentPath));
        }
    }

    return messages;
};
